export default __webpack_public_path__ + "static/media/QR_MNC_NEXT.c1e5b100.PNG";